import { Component, computed, input } from '@angular/core';
import { NgClass } from '@angular/common';

export type SpinnerSize = 'sm' | 'md' | 'lg';

const spinnerSizeMap: Record<SpinnerSize, string> = {
  sm: 'tw-size-spacing-250',
  md: 'tw-size-spacing-400',
  lg: 'tw-size-spacing-800',
};


@Component({
  selector: 'app-spinner',
  imports: [NgClass],
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  public readonly size = input<SpinnerSize>('md');
  public readonly strokeColorClass = input<string>('tw-stroke-component-loader');

  protected readonly sizeClass = computed(() => spinnerSizeMap[this.size()]);

}
